import React from "react";

import { useDocumentTitle } from "./DocumentTitle";
import { usePageHeader } from "../../features/page-header/hooks";
import { IPageProps } from "./definitions";
import { useBreadcrumbs } from "../../features/breadcrumbs/hooks";
import { Breadcrumbs } from "../../features/breadcrumbs/Breadcrumbs";
import { useTable } from "../table/hooks";

const Page: React.FC<IPageProps> = ({
    children,
    className,
    hasBreadcrumbs,
    title,
    subheader,
    description,
    actions,
    currentTable,
}) => {
    const updatePageTitle = useDocumentTitle();
    const { updateBreadcrumbs } = useBreadcrumbs();
    const { updatePageHeader } = usePageHeader();
    const { updateCurrentTable } = useTable();

    React.useEffect(() => {
        updatePageTitle(title);
        updateCurrentTable(currentTable);

        updateBreadcrumbs(
            hasBreadcrumbs
                ? [
                      { text: "Home", href: "/" },
                      { text: title, href: "#" },
                      { text: subheader, href: "#" },
                  ]
                : []
        );
        updatePageHeader({
            title,
            description,
            actions,
        });
    }, []);

    return (
        <section className={`page ${className ?? ""}`} data-testid="page">
            {hasBreadcrumbs ?? <Breadcrumbs />}
            {children}
        </section>
    );
};

export default Page;
